module.exports = __webpack_public_path__ + "static/media/pro6.c6ae19ad.jpg";